export default __webpack_public_path__ + "static/media/maks.be0169fd.jpg";